import {
  Flex,
  Table,
  Checkbox,
  Tbody,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  CheckboxGroup,
  Stack,
  Image,
  Alert,
  AlertIcon,
} from "@chakra-ui/react";
import React, { useContext } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";

// Custom components
import Card from "components/card/Card";
import Menu from "components/menu/MainMenu";
import { useAuthContext } from "hooks/useAuthContext";
import { useState, useEffect } from "react";
import { DeleteIcon, EditIcon } from "@chakra-ui/icons";
import Amazon from "assets/img/amazon.ico";
import Flipkart from "assets/img/flipkart.ico";
import Snapdeal from "assets/img/snapdeal.ico";
import Meesho from "assets/img/meesho.ico";
import Glowroad from "assets/img/glowroad.ico";
import Freeup from "assets/img/freeup.ico";
import _ from "lodash";
import { FaExpand } from "react-icons/fa";
import { CgExpand } from "react-icons/cg";
import { MdExpandMore } from "react-icons/md";
import { SearchBar } from "components/navbar/searchBar/SearchBar";
export default function PRCheckTable() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const { user } = useAuthContext();
  const userInfo = JSON.parse(localStorage.getItem("PAuser"));
  const isAdmin = userInfo?.message?.isAdmin || false;
  const [keywords, setKeywords] = useState([]);
  const [inputKeyword, setInputKeyword] = useState("");
  const [inputManu, setInputManu] = useState("");
  const [inputBrand, setInputBrand] = useState("");
  const [inputError, setInputError] = useState(false);
  const [platforms, setPlatforms] = useState([]);
  const [selectedPlatforms, setSelectedPlatforms] = useState([]); // For new entries
  const [editSelectedPlatforms, setEditSelectedPlatforms] = useState({}); // For edit mode per row
  const [insertKeywords, setInsertKeyword] = useState([]);
  const [editMode, setEditMode] = useState({});
  const [uniqueKeywords, setUniqueKeywords] = useState([]);
  const [successAlert, setSuccesAlert] = useState("");
  const [failureAlert, setFailureAlert] = useState("");
  const [expandedKeyword, setExpandedKeyword] = useState();
  const [groupedByIdKeywords, setGroupedByIdKeywords] = useState();
  const [selectedSearchTerms, setSelectedSearchTerms] = useState([]);
  const [selectedPlatform, setSelectedPlatform] = useState({});

  const handleSuccessAlert = async (alertMessage) => {
    setSuccesAlert(alertMessage);
    setTimeout(() => {
      setSuccesAlert("");
    }, 5000);
  };
  const handleFailureAlert = async (alertMessage) => {
    setFailureAlert(alertMessage);
    setTimeout(() => {
      setFailureAlert("");
    }, 5000);
  };

  const fetchKeywords = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/keyword/getKeywords/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: userInfo?.message?.result.id,
        }),
      });

      const json = await response.json();

      if (response.ok) {
        setKeywords(json);
        setInsertKeyword([]);
      } else if (response.status === 400) {
        handleFailureAlert("Error getting keywords");
      }
    } catch (e) {
      handleFailureAlert("Error getting keywords");
    }
  };

  const fetchPlatforms = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/platforms/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const json = await response.json();
      if (response.ok) {
        setPlatforms(json);
      } else if (response.status === 400) {
        handleFailureAlert("Error Fetching Platforms");
      }
    } catch (e) {
      handleFailureAlert("Error Fetching Platforms");
    }
  };

  const handleSearch = async (text) => {
    try {
      if (text) {
        const filtered = keywords.filter(
          (item) =>
            item.keyword?.toLowerCase().includes(text?.toLowerCase()) ||
            item.manufacturer?.toLowerCase().includes(text?.toLowerCase()) ||
            item.brand?.toLowerCase().includes(text?.toLowerCase())
        );
        setKeywords(filtered);
      } else {
        setKeywords(keywords || []);
      }
    } catch (e) {
      console.error("error in search", e);
    }
  };

  useEffect(() => {
    fetchKeywords();
    fetchPlatforms();
  }, [userInfo?.message?.result.id]);

  const headings = ["SR NO.", "KEYWORDS", "MANUFACTURER", "BRAND"];
  if (isAdmin) {
    headings.splice(4, 0, "PLATFORM");
  }
  headings.push("");

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  const handleDeleteButton = async (row) => {
    try {
      const confirm = window.confirm("Are you sure");
      if (!confirm) return;
      const response = await fetch(`${backendUrl}/api/keyword/disable`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          keyword_id: [row.keyword_id],
        }),
      });

      const json = await response.json();

      if (response.ok) {
        handleSuccessAlert("Keyword Deleted");
        fetchKeywords();
      } else if (response.status === 400) {
        handleFailureAlert("Error in deletion");
      }
    } catch (err) {
      handleFailureAlert("Error in deletion");
    }
  };

  const handleNewDeleteButton = async (row) => {
    try {
      setInsertKeyword(
        insertKeywords.filter(
          (item) =>
            item.keyword !== row.keyword ||
            item.manufacturer !== row.manufacturer ||
            item.brand !== row.brand
        )
      );
    } catch (err) {
      console.log("error in deleting", err);
    }
  };

  const handleEditButton = async (row) => {
    try {
      // Initialize the selected platforms for this row with current platforms
      const currentPlatforms = row.platforms
        .filter(
          (platform) =>
            platform.pmp_status === 1 ||
            platform.pmp_status === 2 ||
            platform.pmp_status === 3
        )
        .map((platform) => platform.pf_id);
      setEditSelectedPlatforms({
        ...editSelectedPlatforms,
        [row.keyword_id]: currentPlatforms,
      });
      setEditMode({ ...editMode, [row.keyword_id]: true });
    } catch (err) {
      console.log("error in edit button");
    }
  };

  const handleSaveEdit = async (row) => {
    try {
      const response = await fetch(`${backendUrl}/api/keyword/updatePlatform`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: row.keyword_id,
          pids: editSelectedPlatforms[row.keyword_id] || [],
        }),
      });

      const json = await response.json();

      if (response.ok) {
        handleSuccessAlert("Changes Saved");
        await fetchKeywords();
        setEditMode({ ...editMode, [row.keyword_id]: false });
        setEditSelectedPlatforms({
          ...editSelectedPlatforms,
          [row.keyword_id]: [],
        }); // Reset after save
      } else if (response.status === 400) {
        handleFailureAlert("Error in saving changes. Please try again!");
      }
    } catch (err) {
      handleFailureAlert("Error in saving changes. Please try again!");
    }
  };

  const createUniqueKeyword = () => {
    let groupedKeywordsByID = _.groupBy(keywords, "id");
    setGroupedByIdKeywords(groupedKeywordsByID);
    let filteredKeywords = Object.values(groupedKeywordsByID).map((item) => {
      const keyword_id = item[0].id;
      const keyword = item[0].name;
      const brand = item[0].brand;
      const manufacturer = item[0].manufacturer;

      const platforms = item
        .map((searchTerm) => ({
          pf_id: searchTerm.pmp_pf_id,
          pmp_status: searchTerm.pmp_status,
          platform_name: searchTerm.platform_name,
        }))
        .filter(
          (platform, index, self) =>
            index === self.findIndex((t) => t.pf_id === platform.pf_id)
        );

      return { keyword_id, keyword, brand, manufacturer, platforms };
    });

    setUniqueKeywords(filteredKeywords);
  };

  const handleExpand = (row) => {
    if (expandedKeyword === row.keyword_id) {
      setExpandedKeyword();
    } else {
      setExpandedKeyword(row.keyword_id);
    }
  };

  useEffect(() => {
    createUniqueKeyword();
  }, [keywords]);

  const HandlePlatformsRender = ({ platforms, row }) => {
    return platforms.map((it, index) => {
      const isGrayscale = it.pmp_status === 2 || it.pmp_status === 3;

      if (it.pmp_status === 1 || it.pmp_status === 2 || it.pmp_status === 3) {
        return (
          <React.Fragment key={index}>
            {it.pf_id === 1 && (
              <Image
                boxSize="15px"
                objectFit="cover"
                src={Amazon}
                alt="Amazon Icon"
                mr="5px"
                filter={isGrayscale ? "grayscale(100%)" : "none"}
              />
            )}
            {it.pf_id === 2 && (
              <Image
                boxSize="15px"
                objectFit="cover"
                src={Flipkart}
                alt="Flipkart Icon"
                mr="5px"
                filter={isGrayscale ? "grayscale(100%)" : "none"}
              />
            )}
            {it.pf_id === 3 && (
              <Image
                boxSize="15px"
                objectFit="cover"
                src={Meesho}
                alt="Meesho Icon"
                mr="5px"
                filter={isGrayscale ? "grayscale(100%)" : "none"}
              />
            )}
            {it.pf_id === 7 && (
              <Image
                boxSize="15px"
                objectFit="cover"
                src={Freeup}
                alt="Freeup Icon"
                mr="5px"
                filter={isGrayscale ? "grayscale(100%)" : "none"}
              />
            )}
          </React.Fragment>
        );
      }
      return null;
    });
  };

  const handleKeywordCheck = (row) => {
    const currentPlatforms = row.platforms
      .filter((platform) => platform.pmp_status === 1)
      .map((platform) => platform.pf_id);

    if (selectedPlatform[row.keyword_id]?.length === currentPlatforms.length) {
      // If all are selected, uncheck them
      setSelectedPlatform({ ...selectedPlatform, [row.keyword_id]: [] });
    } else {
      // Otherwise, check all platforms with pmp_status of 1
      setSelectedPlatform({
        ...selectedPlatform,
        [row.keyword_id]: currentPlatforms,
      });
    }
  };

  const getSelectedPlatformJson = () => {
    const selectedPlatformJson = {};
    Object.keys(selectedPlatform).forEach((keywordId) => {
      selectedPlatformJson[keywordId] = selectedPlatform[keywordId];
    });
    return selectedPlatformJson;
  };

  const handleSendDataForAll = async (searchType) => {
    const payload = {
      ids: getSelectedPlatformJson(),
      crawlType: searchType,
    };

    try {
      const response = await fetch(`${backendUrl}/api/keyword/initCrawler`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const json = await response.json();

      if (response.ok) {
        console.log("Successfully sent data:", json);
        handleSuccessAlert("Data sent successfully!");
      } else {
        handleFailureAlert("Error sending data: " + json.message);
      }
    } catch (error) {
      handleFailureAlert("Network error: " + error.message);
    }
  };

  return (
    <Card
      direction="column"
      w="100%"
      px="0px"
      overflowX={{ sm: "scroll", lg: "hidden" }}
      mb="20px"
    >
      <Flex px="25px" justify="space-between" align="center" gap="10px">
        <Text px="20px" pt="10px">
          Total Keywords: {uniqueKeywords.length}
        </Text>
      </Flex>
      <Flex px="25px" justify="space-between" align="center">
        <SearchBar
          m="10px"
          borderRadius="30px"
          onChange={(e) => handleSearch(e.target.value)}
        />
        {isAdmin && (

        <Flex px="25px" justify="space-between" align="center" gap="10px">
          <Button
            variant="action"
            ml="5px"
            onClick={() => handleSendDataForAll("P")}
          >
            Run Product Search
          </Button>
          <Button
            variant="action"
            ml="5px"
            onClick={() => handleSendDataForAll("R")}
          >
            Recrawl
          </Button>
        </Flex>
        )}
      </Flex>
      <Table variant="simple" color="gray.500" mb="24px">
        <Thead>
          <Tr>
            <Th borderColor={borderColor}></Th>
            {headings.map((column, index) => (
              <Th pe="10px" key={index} borderColor={borderColor}>
                <Flex
                  justify="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  {column}
                </Flex>
              </Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {uniqueKeywords?.map((row, index) => {
            return (
              <>
                <Tr key={index}>
                  <Td
                    fontSize={{ sm: "14px" }}
                    minW={{ sm: "100px", md: "200px", lg: "auto" }}
                    borderColor="transparent"
                  ></Td>

                  <Td
                    fontSize={{ sm: "14px" }}
                    minW={{ sm: "150px", md: "200px", lg: "auto" }}
                    borderColor="transparent"
                  >
                    <Flex align="center">
                      <Text color={textColor} fontSize="md" fontWeight="700">
                        {index + 1}
                      </Text>
                    </Flex>
                  </Td>
                  <Td
                    fontSize={{ sm: "14px" }}
                    minW={{ sm: "150px", md: "200px", lg: "auto" }}
                    borderColor="transparent"
                  >
                    <Flex align="center">
                      <Text color={textColor} fontSize="md" fontWeight="700">
                        {row.keyword}
                      </Text>
                    </Flex>
                  </Td>
                  <Td
                    fontSize={{ sm: "14px" }}
                    minW={{ sm: "150px", md: "200px", lg: "auto" }}
                    borderColor="transparent"
                  >
                    <Flex align="center">
                      <Text color={textColor} fontSize="md" fontWeight="700">
                        {row.manufacturer}
                      </Text>
                    </Flex>
                  </Td>
                  <Td
                    fontSize={{ sm: "14px" }}
                    minW={{ sm: "150px", md: "200px", lg: "auto" }}
                    borderColor="transparent"
                  >
                    <Flex align="center">
                      <Text color={textColor} fontSize="md" fontWeight="700">
                        {row.brand}
                      </Text>
                    </Flex>
                  </Td>
                  {isAdmin && (
                    <>
                      {!editMode[row.keyword_id] ? (
                        <Td
                          fontSize={{ sm: "14px" }}
                          minW={{ sm: "150px", md: "200px", lg: "auto" }}
                          borderColor="transparent"
                        >
                          <Flex align="center">
                            <HandlePlatformsRender
                              platforms={row.platforms}
                              row={row}
                            />
                          </Flex>
                        </Td>
                      ) : (
                        <Td>
                          <Stack pl={6} mt={1} spacing={1}>
                            <Checkbox
                              isChecked={
                                editSelectedPlatforms[row.keyword_id]
                                  ?.length === platforms.length
                              }
                              onChange={(e) => {
                                if (e.target.checked) {
                                  const allPlatformIds = platforms.map(
                                    (platform) => platform.id
                                  );
                                  setEditSelectedPlatforms({
                                    ...editSelectedPlatforms,
                                    [row.keyword_id]: allPlatformIds,
                                  });
                                } else {
                                  setEditSelectedPlatforms({
                                    ...editSelectedPlatforms,
                                    [row.keyword_id]: [],
                                  });
                                }
                              }}
                            >
                              ALL
                            </Checkbox>
                            {platforms.map((platform, index) => (
                              <Checkbox
                                key={index}
                                isChecked={editSelectedPlatforms[
                                  row.keyword_id
                                ]?.includes(platform.id)}
                                onChange={(e) => {
                                  const current =
                                    editSelectedPlatforms[row.keyword_id] || [];
                                  if (e.target.checked) {
                                    setEditSelectedPlatforms({
                                      ...editSelectedPlatforms,
                                      [row.keyword_id]: [
                                        ...current,
                                        platform.id,
                                      ],
                                    });
                                  } else {
                                    setEditSelectedPlatforms({
                                      ...editSelectedPlatforms,
                                      [row.keyword_id]: current.filter(
                                        (id) => id !== platform.id
                                      ),
                                    });
                                  }
                                }}
                              >
                                {platform.platform_name}
                              </Checkbox>
                            ))}
                          </Stack>
                        </Td>
                      )}
                      <Td
                        fontSize={{ sm: "14px" }}
                        minW={{ sm: "150px", md: "200px", lg: "auto" }}
                        borderColor="transparent"
                      >
                        <Flex align="center">
                          <Button
                            colorScheme="gray"
                            onClick={() => handleDeleteButton(row)}
                          >
                            <Icon as={DeleteIcon} />
                          </Button>
                          {!editMode[row.keyword_id] ? (
                            <Button
                              colorScheme="gray"
                              onClick={() => handleEditButton(row)}
                            >
                              <Icon as={EditIcon} />
                            </Button>
                          ) : (
                            <Button
                              colorScheme="messenger"
                              size="md"
                              onClick={() => handleSaveEdit(row)}
                            >
                              Save
                            </Button>
                          )}
                          <Button
                            colorScheme="gray"
                            onClick={() => handleExpand(row)}
                          >
                            <Icon as={MdExpandMore} />
                          </Button>
                        </Flex>
                      </Td>
                    </>
                  )}
                </Tr>
                {expandedKeyword === row.keyword_id && (
                  <Tr minW={{ sm: "150px", md: "200px", lg: "auto" }}>
                    {row.platforms
                      // .filter((pmp) => pmp.pmp_status === 1)
                      .filter((pmp) => pmp.platform_name !== null)
                      .map((item, index) => (
                        <Tr key={index}>
                          <Td>
                            <Checkbox
                              isChecked={selectedPlatform[
                                row.keyword_id
                              ]?.includes(item.pf_id)}
                              onChange={(e) => {
                                const currentSelected =
                                  selectedPlatform[row.keyword_id] || [];
                                if (e.target.checked) {
                                  setSelectedPlatform({
                                    ...selectedPlatform,
                                    [row.keyword_id]: [
                                      ...currentSelected,
                                      item.pf_id,
                                    ],
                                  });
                                } else {
                                  setSelectedPlatform({
                                    ...selectedPlatform,
                                    [row.keyword_id]: currentSelected.filter(
                                      (id) => id !== item.pf_id
                                    ),
                                  });
                                }
                              }}
                            />{" "}
                            {item.platform_name}
                          </Td>
                        </Tr>
                      ))}
                  </Tr>
                )}
              </>
            );
          })}
          {insertKeywords.map((row, index) => {
            return (
              <Tr key={index}>
                <Td
                  fontSize={{ sm: "14px" }}
                  minW={{ sm: "150px", md: "200px", lg: "auto" }}
                  borderColor="transparent"
                >
                  <Flex align="center">
                    <Text color={textColor} fontSize="md" fontWeight="700">
                      {keywords.length + index + 1}
                    </Text>
                  </Flex>
                </Td>
                <Td
                  fontSize={{ sm: "14px" }}
                  minW={{ sm: "150px", md: "200px", lg: "auto" }}
                  borderColor="transparent"
                >
                  <Flex align="center">
                    <Text color={textColor} fontSize="md" fontWeight="700">
                      {row.keyword}
                    </Text>
                  </Flex>
                </Td>
                <Td
                  fontSize={{ sm: "14px" }}
                  minW={{ sm: "150px", md: "200px", lg: "auto" }}
                  borderColor="transparent"
                >
                  <Flex align="center">
                    <Text color={textColor} fontSize="md" fontWeight="700">
                      {row.manufacturer}
                    </Text>
                  </Flex>
                </Td>
                <Td
                  fontSize={{ sm: "14px" }}
                  minW={{ sm: "150px", md: "200px", lg: "auto" }}
                  borderColor="transparent"
                >
                  <Flex align="center">
                    <Text color={textColor} fontSize="md" fontWeight="700">
                      {row.brand}
                    </Text>
                  </Flex>
                </Td>
                <Td
                  fontSize={{ sm: "14px" }}
                  minW={{ sm: "150px", md: "200px", lg: "auto" }}
                  borderColor="transparent"
                >
                  <Flex align="center">
                    {row.platformIds.includes(1) && (
                      <Image
                        boxSize="15px"
                        objectFit="cover"
                        src={Amazon}
                        alt="Amazon Icon"
                        mr="5px"
                      />
                    )}
                    {row.platformIds.includes(2) && (
                      <Image
                        boxSize="19px"
                        objectFit="cover"
                        src={Flipkart}
                        alt="Flipkart Icon"
                        mr="5px"
                      />
                    )}
                    {row.platformIds.includes(3) && (
                      <Image
                        boxSize="15px"
                        objectFit="cover"
                        src={Meesho}
                        alt="Meesho Icon"
                        mr="2px"
                      />
                    )}
                    {row.platformIds.includes(7) && (
                      <Image
                        boxSize="15px"
                        objectFit="cover"
                        src={Freeup}
                        alt="Freeup Icon"
                        mr="2px"
                      />
                    )}
                  </Flex>
                </Td>
                <Td
                  fontSize={{ sm: "14px" }}
                  minW={{ sm: "150px", md: "200px", lg: "auto" }}
                  borderColor="transparent"
                >
                  <Flex align="center">
                    <Button
                      colorScheme="gray"
                      onClick={() => handleNewDeleteButton(row)}
                    >
                      <Icon as={DeleteIcon} />
                    </Button>
                  </Flex>
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
      <Stack spacing={3} position="fixed" right="10px" bottom="2vh">
        {successAlert !== "" && (
          <Alert status="success" variant="left-accent" w="40vw">
            <AlertIcon />
            {successAlert}
          </Alert>
        )}
        {failureAlert !== "" && (
          <Alert status="error" variant="left-accent" w="40vw">
            <AlertIcon />
            {failureAlert}
          </Alert>
        )}
      </Stack>
    </Card>
  );
}
